import { getAccessTokenFromCookie } from "../util/authentication";
import { SENIORITY_API_GENERATE_SENIORITY_LIST, EMPLOYEE_API_GET_LAST_PUB_SL_EVENT, EMPLOYEE_API_GET_LAST_PUB_SL_EVENT_BY_DECLARATION } from "../util/constants";

export const fetchSeniorityList = async (station, workgroup, seniorityListType) => {
  const apiEndpoint =
    process.env.REACT_APP_SENIORITY_API +
    SENIORITY_API_GENERATE_SENIORITY_LIST +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    seniorityListType;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const getLatestPubSLEvent = async (station, workgroup, seniorityListType) => {
  const apiEndpoint =
    process.env.REACT_APP_EMPLOYEE_SERVICE_API +
    EMPLOYEE_API_GET_LAST_PUB_SL_EVENT +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    seniorityListType;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const getLatestPubSLEventByDeclaration = async (
  station,
  workgroup,
  seniorityListType,
  declaration,
  declarationYear
) => {
  const apiEndpoint =
    process.env.REACT_APP_EMPLOYEE_SERVICE_API +
    EMPLOYEE_API_GET_LAST_PUB_SL_EVENT_BY_DECLARATION +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    seniorityListType +
    "/" +
    declaration +
    "/" +
    declarationYear;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};
